import { BrandsOwned } from '../../common/types';
import apiClient from '../apiClient';

export const fetchUserData = async (token: string, uid: string, language: string): Promise<BrandsOwned> => {
	try {
		console.debug('🔄 [FETCH_USER_DATA] Starting request with:', { uid, language, hasToken: !!token });
		
		const userData = await apiClient(`/users/get_owned/`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
			body: JSON.stringify({ uid, language }),
		});
		console.debug('Token: ', token);
		console.debug('📦 [FETCH_USER_DATA] Raw response:', userData);

		// Handle cases where brandsOwned might be undefined or null
		const brandsOwned = userData?.brandsOwned || [];

		const processedData = {
			brandsOwned: brandsOwned,
		};

		console.debug('✅ [FETCH_USER_DATA] Processed data:', processedData);
		return processedData;
	} catch (error) {
		console.error('❌ [FETCH_USER_DATA] Error details:', {
			error,
			message: error instanceof Error ? error.message : 'Unknown error',
			stack: error instanceof Error ? error.stack : undefined
		});
		throw new Error(`USER_DATA_FETCH_FAILED: ${error instanceof Error ? error.message : 'Unknown error'}`);
	}
};
